// The per-company config is resolved at build time via the `@companyConfig`
// alias defined in vue.config.js (driven by VUE_APP_COMPANY). Only the config
// for the current deployment ends up in the bundle.
import companyDetails from '@companyConfig'

export default {
	service: (() => {
		const apiRootURL = (process.env.VUE_APP_API_ROOT_URL || '').replace(/\/?$/, '/')

		return {
			baseURL: process.env.VUE_APP_BASE_URL,
			apiRootURL,
			apiURL: `${apiRootURL}api/`,
			orderPdfURL: `${apiRootURL}order-pdf/`,
			routePdfURL: `${apiRootURL}route-pdf/`,
			routeMapPdfURL: `${apiRootURL}route-map-pdf/`,
			routeMapDocURL: `${apiRootURL}route-map-doc/`,
			routeProductionPdfURL: `${apiRootURL}route-production-pdf/`,
			routeProductionDocURL: `${apiRootURL}route-production-doc/`,
			orderDocURL: `${apiRootURL}order-doc/`,
			routeDocURL: `${apiRootURL}route-doc/`
		}
	})(),
	company: companyDetails,
	mapboxAccessToken: process.env.VUE_APP_MAPBOX_ACCESS_TOKEN
}
